const nationalAverage = {
  supply: 5.0,
  medianPrice: '398,500',
  yoyChange: 8.6,
  affordability: 90.4,
  popChange: 6.5
};

export default nationalAverage;
